import { render, staticRenderFns } from "./ContentReport.vue?vue&type=template&id=8fef8854"
import script from "./ContentReport.vue?vue&type=script&lang=js"
export * from "./ContentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports